import React, {Fragment, useEffect, useState} from 'react'
import {Form, Modal} from 'react-bootstrap'
import {useDispatch, useSelector} from 'react-redux'
import CartaCiaTercero from './cartaCiaTercero'
import {useFormik} from 'formik'
import { postActualizarCIATercero} from '../../../../store/actions/carta-cia-tercero-acttion'
import Acciones from './acciones'
import { LoadingComponent } from 'recupero-comunes'
import 'recupero-comunes/dist/index.css'
import  {validationSchemas}  from '../../../../common/validation-Schemas-cata-CIA'
import { obtenerDatosGestionImplicado } from '../../../../store/actions/proceso-extrajudicial-action'
import { limpiarRefAction } from '../../../../store/actions/proceso-judicial-action'
// import Historial from './historial'
const CartaCiaTerceroModal = ({showCIA, handleCloseCIA}) => {
    const [loading, setLoading]=useState(false) 
    const data_recepciona = useSelector((state) => state.recepcionaCasoReducer)
    const {llaves} = data_recepciona
    const data_proceso_extrajudicial = useSelector((state) => state.procesoExtrajudicialReducer)
    const {datosGestionImplicado} = data_proceso_extrajudicial
    const [porcConvData, setPorcConvData] = useState('')
    const [porcConvOldData, setPorcConvOldData] = useState('')
    const [montoNetoCompara, setMontoNetoCompara] = useState('')
    const [mirecobroSinFormato, setMirecobroSinFormato]=useState('')
    const [showToast, setShowToast] = useState(false);
    const handleCloseToast = () => setShowToast(false)
    const handleShowToast = () => setShowToast(true) 
    const data_modal_cia = useSelector((state) => state.modalCartaCiaTerceroReducer)
    const {loadingCarta, montosInformados} = data_modal_cia
    const [modedadata, setMonedaData] = useState('')
    const dispatch = useDispatch()
    

    const formik = useFormik({
        initialValues: {
            "idCaso": "",
            "idImplicadoCaso": "",
            "idOrganizacion": "",
            "tipoVehiculoIM": null,
            "patenteIM": null,
            "marcaVehiculoIM": null,
            "detalleDescripcionIM": null,
            "seguroIM": 212003, //Seguro Confirmado
            "idCompaniaIM": null,
            "idSiniestroIM": null,
            "fechaSiniestroIM": null,
            "moneda": "",
            "montoCosto": "",
            "porcConvenio": "",
            "porcConvenioOld": "",
            "montoRecobro": "",
            "motivoExcepcion": null,
            "observaciones": null,
            "destinatarioCia": null,
            "emailDestinatario": null,
            "idUsuario": "",
            "enviaCarta": "2",
            "fechaEnvioCarta": ""
        },
        validationSchema: validationSchemas(montoNetoCompara),
        onSubmit: (formData) => {
          const dataForm = {
              ...formData
          }
          setLoading(true)
          dataForm['idCaso'] = llaves && llaves['idCaso']
          dataForm['idImplicadoCaso'] = llaves && llaves['idImplicado']
          dataForm['idOrganizacion'] = llaves && llaves['idOrgCaso']
          dataForm['idUsuario'] = llaves && llaves['idUsuario']
          dataForm['codTipoGestion'] = datosGestionImplicado && datosGestionImplicado.datosGestionImplicado[0]['codTipoGestion']
          dataForm['codAmbitoGestion'] = datosGestionImplicado && datosGestionImplicado.datosGestionImplicado[0]['codAmbitoGestion']
          dataForm['moneda'] = montosInformados && montosInformados.montosInformados[0]['CodMoneda'] !== undefined && montosInformados.montosInformados[0]['CodMoneda'] !== null && montosInformados.montosInformados[0]['CodMoneda'] !== '' ? montosInformados.montosInformados[0]['CodMoneda'] : ''
          dataForm['montoCosto'] = montosInformados && montosInformados.montosInformados[0]['MontoCosto'] !== undefined && montosInformados.montosInformados[0]['MontoCosto'] !== null && montosInformados.montosInformados[0]['MontoCosto'] !== '' ? montosInformados.montosInformados[0]['MontoCosto'] : ''
          dataForm['porcConvenio'] = porcConvData//montosInformados && montosInformados.montosInformados[0]['PorConvenidoEntreCias'] !== undefined && montosInformados.montosInformados[0]['PorConvenidoEntreCias'] !== null && montosInformados.montosInformados[0]['PorConvenidoEntreCias'] !== '' ? montosInformados.montosInformados[0]['PorConvenidoEntreCias'] : ''
          dataForm['porcConvenioOld'] = porcConvOldData 
          dataForm['montoRecobro'] = mirecobroSinFormato             

          if (formData.file) {
              getBase64(formData.file).then((base64data) => { 
                  const fileData = base64data.split(',')[1]
                  let data = { ...dataForm, "filename": formData.file.name, "mimetype": formData.file.type, "base64data": fileData };
                  dispatch(postActualizarCIATercero(data)).then(()=>UpdateUltimoHito())
                  .then(()=>{
                    dispatch(limpiarRefAction(true))
                    handleShowToast()
                    formik.touched.file=false
                  })
                .then(()=>{
                  delete formData['file']
                })
                .then(()=>setLoading(false))            
              })
          } else {
              //console.log("setPorcConv:", porcConvData);
              //console.log("setPorcConvOld:", porcConvOldData);
              //console.log("setMiRecobro:", mirecobroSinFormato);
              dispatch(postActualizarCIATercero(dataForm)).then(()=>UpdateUltimoHito()).then(()=>setLoading(false))
              handleShowToast()
          } 
        }
    })
    const UpdateUltimoHito=()=>{
        setLoading(true)
        if (llaves) {
    
          let query = Buffer.from(
            JSON.stringify({ "idCaso": llaves && llaves["idCaso"], "idImplicado": llaves && llaves["idImplicado"] })
          ).toString('base64')
          dispatch(obtenerDatosGestionImplicado(query)).then(()=>setLoading(false))
        }
      }
    return (
        <> <LoadingComponent show={loadingCarta}/>
        <LoadingComponent show={loading}/>
            <Modal show={showCIA}
                onHide={handleCloseCIA}
                size='xl'>
                <Form onSubmit={
                    formik.handleSubmit
                }>
                    <CartaCiaTercero formik={formik}
                        setPorcConvData = {setPorcConvData}
                        setPorcConvOldData = {setPorcConvOldData}
                        setMontoNetoCompara = {setMontoNetoCompara}
                        setMirecobroSinFormato = {setMirecobroSinFormato}
                        showToast = {showToast}
                        setShowToast = {setShowToast}
                        />
                    <Acciones handleCloseCIA={handleCloseCIA}/>
                </Form>
            </Modal>
        </>
    )
}

export default CartaCiaTerceroModal
const getBase64 = (file) => {
    return new Promise(resolve => {
        let reader = new FileReader();
        // Convert the file to base64 text
        reader.readAsDataURL(file);
        reader.onload = () => {
            resolve(reader.result);
        };
    });
  };